import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';


const middleware = [
  thunk
];

const configureStore = (rootReducer, restoredState) => createStore(
  rootReducer,
  restoredState,
  compose(applyMiddleware(...middleware))
);

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js